const EmailIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0C6.7125 0 0 6.7125 0 15C0 23.2875 6.7125 30 15 30C23.2875 30 30 23.2875 30 15C30 6.7125 23.2875 0 15 0ZM23.7375 8.725L15 15.8125L6.2625 8.725H23.7375ZM23.75 21.225H6.25V10.5875L15 17.675L23.75 10.5875V21.2125V21.225Z"
        fill="#3C3C3B"
      />
    </svg>
  );
};

export default EmailIcon;
